export default __webpack_public_path__ + "static/media/o_wdt_c_0.ddc568fc.mp3";